import React from 'react'
import { Link } from "react-router-dom";

export default function Header() {
    return (
        <div>
            <header className="main-header">
                <div className="container">
                    <div className="tophead">
                        <div className="row align-items-center">
                            <div className="col-md-3 col-7 moblogo d-flex align-items-center">
                                <button
                                    className="navbar-toggler d-sm-none d-block"
                                    type="button"
                                >
                                    <img
                                        src="/images/left-menu.svg"
                                        alt="Menu"
                                        className="left-imgsidebar"
                                    />
                                </button>

                                <Link to="/" className="ms-2">
                                    <img src="/images/logo.svg" className="logo-img" alt="Logo" />
                                </Link>
                            </div>

                            <div className="col-md-5 p-sm-0 p-3">
                                <ul className="tophead-right">
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">Services</a>
                                    </li>
                                    <li>
                                        <a href="#">How we works?</a>
                                    </li>
                                    <li>
                                        <a href="#">Connect</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-4">
                                <div className="get-started-btn">
                                    <Link to="/login" className="btn btn-login">
                                        Login
                                    </Link>
                                    {/* <button className="btn btn-login btn-login-2"> */}
                                    <Link to="/signup" className="btn btn-login btn-login-2">

                                        Get Started!
                                    </Link>
                                    {/* </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}
